import React, { useEffect, useState } from 'react';
import { TEST_IDS } from '@constants/testIds.ts';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { translateItem } from '@utils/translations.ts';

import {
    CardProgressBarGraphic,
    CardProgressBarSpendTime,
    CardProgressBarWrapper,
    CardProgressMinLeft,
    CardProgressText,
    CardProgressTextPercent,
} from './styled.tsx';

export const SHARED_CARD_PROGRESS_BAR_MIN_LEFT = msg`min left`;

interface Props {
    percentComplete: string;
    minLeft: number;
    isCustomText: boolean;
    bgColor?: string;
    progressColor?: string;
    animated?: boolean;
}

const CardProgressBar: React.FC<Props> = ({
    percentComplete,
    minLeft,
    isCustomText,
    bgColor,
    progressColor,
    animated = false,
}) => {
    const { t } = useLingui();

    const [progress, setProgress] = useState(animated ? '0' : percentComplete);

    useEffect(() => {
        setProgress(percentComplete);
    }, [percentComplete]);

    useEffect(() => {
        if (!animated) return;

        const frame = requestAnimationFrame(() => {
            setProgress(percentComplete);
        });
        return () => cancelAnimationFrame(frame);
    }, [percentComplete, animated]);

    return (
        <CardProgressBarWrapper data-cy={TEST_IDS.SIDEBAR.CARD_PROGRESS_BAR}>
            <CardProgressBarGraphic data-cy={TEST_IDS.SIDEBAR.CARD_PROGRESS_BAR_TRACK} $bgColor={bgColor}>
                <CardProgressBarSpendTime
                    data-cy={TEST_IDS.SIDEBAR.CARD_PROGRESS_BAR_FILL}
                    $progressPercent={progress}
                    $bgColor={progressColor}
                    $animated={animated}
                ></CardProgressBarSpendTime>
            </CardProgressBarGraphic>
            {!isCustomText && (
                <CardProgressText>
                    <CardProgressTextPercent data-cy={TEST_IDS.SIDEBAR.CARD_PROGRESS_BAR_PERCENT}>
                        {percentComplete}% {t`completed`}
                    </CardProgressTextPercent>
                    <CardProgressMinLeft data-cy={TEST_IDS.SIDEBAR.CARD_PROGRESS_BAR_MIN_LEFT}>
                        {minLeft} {translateItem(SHARED_CARD_PROGRESS_BAR_MIN_LEFT)}
                    </CardProgressMinLeft>
                </CardProgressText>
            )}
        </CardProgressBarWrapper>
    );
};

export default CardProgressBar;
